import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import server from "../../../api/server";
import { useNavigate } from "react-router-dom";
import { MdArrowBack, MdOutlineDescription } from 'react-icons/md';
import { FaEye, FaTimes } from "react-icons/fa";
import ConversationRecords from "../calls/ConversationRecords.jsx";

import { 
    FaLightbulb, 
    FaUser, 
    FaQuestionCircle 
  } from "react-icons/fa";
import '../../../dashboard-components/loader.css';
import { IoChatbubbleOutline, IoChatbubbleSharp } from "react-icons/io5";
import { ChevronsLeft, ChevronsRight, Menu, PencilLine } from "lucide-react";
import { useToast } from "../../../context/ToastContext.jsx";
import Papa from "papaparse";
import { LuDownload } from "react-icons/lu";
import { FiUpload } from "react-icons/fi";
import { IoAlertCircleOutline } from "react-icons/io5";

const CampaignDetails = ({selectedClientId, campaignIdProp, open_type}) => {
    const { showToast } = useToast();
    const { campaignId } = useParams();
    const [client_id, setClient_id] = useState(null);
    const [agent, setAgent] = useState(null);
    const [service_id, setService_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [sections, setSections] = useState([])
    const [showMoreMap, setShowMoreMap] = useState({});
    const [expandedSection, setExpandedSection] = useState(0);
    const [loading, setLoading] = useState(false)
    const [campaignDetailAvailable, setCampaignDetailAvailable] = useState(true)
    const [showConversationPage, setShowConversationPage] = useState(false)
    const [segmentData, setSegmentData] = useState(null)
    const [showSummary, setShowSummary] = useState({});
    const [selectedCallID, setSelectedCallID] = useState(null)
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false)
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const tabRowRef = useRef(null);
    const navigate = useNavigate();
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [selectedTab, setSelectedTab] = useState(null);
    const [selectedCampaignID, setSelectedCampaignID] = useState(null);
    const [selectedBatchID, setSelectedBatchID] = useState(null);
    const [batches, setBatches] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [maxRetries, setMaxRetries] = useState(null);
    const [phone, setPhone] = useState(null);
    const [inputChangeDetected, setInputChangeDetected] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelBatchId, setCancelBatchId] = useState(null);
    const [cancelApiRunning, setCancelApiRunning] = useState(false);
    // Compute filteredSections once per render
  const filteredSections = sections.filter(section => Array.isArray(section.data) ? section.data.length > 0 : section.data);

  // Ensure selectedSection is always in sync with filteredSections
  useEffect(() => {
    if (filteredSections.length > 0) {
      // If expandedSection is null or out of bounds, default to first
      const idx = (expandedSection != null && expandedSection < filteredSections.length) ? expandedSection : null;
      setSelectedSection(filteredSections[idx]);
    } else {
      setSelectedSection(null);
    }
    // eslint-disable-next-line
  }, [sections, expandedSection]);
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    const toggleSummary = (index) => {
        setShowSummary(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

      const getCampaignDetails = async () => {
        setLoading(true)
        const user = getCookie("dashboard_login_user_creds")
          ? JSON.parse(getCookie("dashboard_login_user_creds"))
          : null;
    
        if (user) {
          let clientId = selectedClientId;
          let email = user.email
          // Decode the campaignId if it comes from URL params (it would be encoded)
          const actualCampaignId = campaignIdProp ? campaignIdProp : (campaignId ? decodeURIComponent(campaignId) : campaignId);
          try {
            let res = await server.get_voice_agent_campaign_details(clientId, null, email, "campaigns", undefined, actualCampaignId);
            if(res.status === 200){
                let resp = await res.json();
                setCampaignDetailAvailable(true);
                setMaxRetries(resp.data.max_retries);
                setPhone(resp.data.phone);
                setAgent(resp.data.agent);
            // New simplified schema mapping
            const list = Array.isArray(resp.data?.campaign_data) ? resp.data?.campaign_data : [];
            const mapped = list.map(item => {
              const total_records = Number(item.total_records) || 0;
              const total_initiated = Number(item.total_initiated) || 0;
              const success_count = Number(item.total_completed) || 0; // success
              const failed_count = Number(item.total_error) || 0; // failed
              const total_cancelled = Number(item.total_cancelled) || 0;
              let status = 'queued';
              if ((success_count + failed_count) === total_records && total_records > 0) {
                status = 'completed';
              } else if (success_count > 0 || failed_count > 0) {
                status = 'processing';
              } else if (total_records === total_initiated && success_count === 0 && failed_count === 0) {
                status = 'processing';
              } else if (total_cancelled > 0) {
                status = 'cancelled';
              }
              return {
                campaign_batch_id: item.campaign_batch_id,
                total_records,
                total_initiated,
                success_count,
                failed_count,
                status,
                created_at: item.created_at,
              }
            });
            setBatches(mapped);
            }
          } catch (error) {
          }finally{
            setLoading(false);
          }
        }
      };
      const handleGoBack = () => {
        if(campaignIdProp){
          open_type();
          return;
        }
        navigate(-1); 
      }
      function convertEpochToReadable(epoch_time, isMilliseconds = true, location=undefined) {
        let epoch = null
        if(!location){
          if (epoch_time && epoch_time.call_time){
            epoch = epoch_time.call_time
          }else{
            epoch = epoch_time.time
          }
        }else{
          if(location === 'First'){
            epoch = Number(epoch_time[0].time)
          }else if(location === 'Last'){
            epoch = Number(epoch_time[epoch_time.length-1].time)
          }else{
            epoch = undefined
          }
        }
        // Convert to milliseconds if the epoch is in seconds
        const date = new Date(isMilliseconds ? epoch : epoch * 1000);
    
        // Format the date as "YYYY-MM-DD HH:mm:ss"
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
    const formatEpochToReadableDateString = (epoch) => {
      const date = new Date(epoch*1000);
    
        // Format the date as "YYYY-MM-DD HH:mm:ss"
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    useEffect(() => {
        // Dynamically build the initial showMoreMap based on `data`
        if (campaignDetailAvailable) {
          const initialShowMoreMap = {};
          initialShowMoreMap[`Campaign Summary`] = false;
          setShowMoreMap(initialShowMoreMap);
        }
      }, [campaignDetailAvailable]);
    
    const lastFetchKeyRef = useRef(null);
    useEffect(() => {
      if (!(selectedClientId)) return;
      const actualCampaignId = campaignIdProp ? campaignIdProp : (campaignId ? decodeURIComponent(campaignId) : campaignId);
      const key = `${selectedClientId}|${actualCampaignId}`;
      if (lastFetchKeyRef.current === key) return;
      lastFetchKeyRef.current = key;
      getCampaignDetails();
    }, [selectedClientId, campaignId, campaignIdProp]);
    useEffect(()=> {
      if(selectedClientId){
        setClient_id(selectedClientId)
      }
      const user = getCookie("dashboard_login_user_creds")
        ? JSON.parse(getCookie("dashboard_login_user_creds"))
        : null;
      if(user){
        let email =user.email
        setEmail(email)
      }
    }, [selectedClientId])
    const checkTabRowScroll = () => {
      const el = tabRowRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
  
    useEffect(() => {
      checkTabRowScroll();
      const el = tabRowRef.current;
      if (!el) return;
      el.addEventListener('scroll', checkTabRowScroll);
      window.addEventListener('resize', checkTabRowScroll);
      return () => {
        el.removeEventListener('scroll', checkTabRowScroll);
        window.removeEventListener('resize', checkTabRowScroll);
      };
    }, [filteredSections.length]);
  
    const scrollTabRow = (direction) => {
      const el = tabRowRef.current;
      if (!el) return;
      const scrollAmount = 240; // px
      el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    };
    const handleSourceClick = (source) => {
      if(source.campaign_id){
        setShowBulkUploadModal(true)
        setSelectedSegment(source)
        setSelectedTab(filteredSections[expandedSection].title)
        setSelectedCampaignID(source.campaign_id)
      }
    }
    const formatEpochToReadableDate = (epoch) => {
      return convertEpochToReadable(epoch, true, 'Last');
    }
    const handleBatchesPage = (batch_id) => {
      setShowBulkUploadModal(true)
      setSelectedBatchID(batch_id)
    }
    useEffect(() => {
      const handleEsc = (event) => {
        if (event.key === "Escape") {
          setShowBulkUploadModal(false);
        }
      }
      if (showBulkUploadModal) {
        window.addEventListener('keydown', handleEsc);
      }
      return () => {
        window.removeEventListener('keydown', handleEsc);
      }
    }, [showBulkUploadModal])


    const CancelBatchModal = ({ isOpen, onClose, onConfirm }) => {
      if (!isOpen) return null;
      return (
        <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-4" style={{background: "rgba(0,0,0,0.5)"}}>
          <div className="bg-white rounded-lg shadow-xl w-full" style={{maxWidth: "420px"}}>
            <div className="p-4 border-b flex justify-between items-center">
              <h2 className="text-xl font-semibold" style={{fontSize: "16px"}}>Cancel Batch</h2>
              <FaTimes onClick={onClose} className='cursor-pointer h-4 w-4 text-slate-500' />
            </div>
            <div className="p-5" style={{fontSize: "14px"}}>
              Are you sure you want to cancel this batch?
            </div>
            <div className="p-4 border-t flex justify-end gap-3">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                style={{padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px"}}
                disabled={cancelApiRunning}
              >
                No
              </button>
              <button
                onClick={onConfirm}
                disabled={cancelApiRunning}
                className={`px-4 py-2 ${cancelApiRunning ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'} text-white rounded-md`}
                style={{ padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
              >
                Yes, Cancel
              </button>
            </div>
          </div>
        </div>
      )
    };

    const handleCancelBatchClick = (batchId) => {
      setCancelBatchId(batchId);
      setShowCancelModal(true);
    };

    const handleConfirmCancelBatch = async () => {
      try {
        if (!client_id || !email || !cancelBatchId) {
          showToast("Missing required details to cancel batch.", "error");
          return;
        }
        setCancelApiRunning(true);
        const actualCampaignId = campaignIdProp ? campaignIdProp : (campaignId ? decodeURIComponent(campaignId) : campaignId);
        const resp = await server.cancel_voice_agent_campaign_batch(
          client_id,
          null,
          email,
          'campaigns',
          undefined,
          actualCampaignId,
          cancelBatchId
        );
        if (resp.status === 200) {
          showToast("Batch cancelled successfully.", "success");
          setShowCancelModal(false);
          setCancelBatchId(null);
          await getCampaignDetails();
        } else {
          showToast("Failed to cancel batch.", "error");
        }
      } catch (e) {
        showToast("Failed to cancel batch.", "error");
      } finally {
        setCancelApiRunning(false);
      }
    };

    const BulkUploadModal = ({ isOpen, onClose, onSave, selectedCampaignID }) => {
        const [loading, setLoading] = useState(false);
        const [apiCallRunning, setApiCallRunning] = useState(false);
        const [csvFile, setCsvFile] = useState(null); // parsed rows
        const [csvFileName, setCsvFileName] = useState(null);
        const [selectedFile, setSelectedFile] = useState(null); // File object (Blob)
        const [statement, setStatement] = useState(null);
        const [requiredHeaders, setRequiredHeaders] = useState(["PHONE NUMBER", "CUSTOMER ID"]);
        const [customVarsLowerMap, setCustomVarsLowerMap] = useState({});
        const fileRef = useRef(null);
        const optionalScheduleHeaders = ["SCHEDULED DATE", "SCHEDULED TIME"];
        const phoneNumberColumn = 'phone number';
        const normalizeCsvHeader = (value) => String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
        const isOptionalCustomerNameHeader = (value) => normalizeCsvHeader(value) === 'customer name';

        // Fetch agent details to obtain custom_variables and build required headers
        useEffect(() => {
          const fetchAgentVars = async () => {
            try {
              if (!agent || !client_id || !email) return;
              const res = await server.getAgentDetails(client_id, '', email, 'voice-agents', 'agents', agent);
              if (res.status === 200) {
                const body = await res.json();
                const customVars = (body?.data?.custom_variables) || {};
                const lowerMap = Object.fromEntries(Object.entries(customVars).map(([k, v]) => [String(k).trim().toLowerCase(), v]));
                const dynamicHeaders = Object.keys(lowerMap).map(k => k.toUpperCase());
                const requiredDynamicHeaders = dynamicHeaders.filter((header) => !isOptionalCustomerNameHeader(header));
                setCustomVarsLowerMap(lowerMap);
                setRequiredHeaders(["PHONE NUMBER", "CUSTOMER ID", ...requiredDynamicHeaders]);
              }
            } catch (e) {}
          };
          if (isOpen) {
            fetchAgentVars();
          }
        }, [isOpen, agent, client_id, email]);

        const randomString = (len = 6) => Math.random().toString(36).substring(2, 2 + len);
        const randomNumber = (digits = 4) => Array.from({ length: digits }, () => Math.floor(Math.random() * 10)).join('');
        const randomPhone = () => '9' + randomNumber(9);
        const sampleValueFor = (keyLower) => {
          const normalizedKey = normalizeCsvHeader(keyLower);
          if (normalizedKey === 'phone number') return randomPhone();
          if (normalizedKey === 'scheduled date' || normalizedKey === 'scheduled time') return '';
          const meta = customVarsLowerMap[keyLower];
          if (meta && meta.default_value) return String(meta.default_value);
          const type = (meta && meta.type) ? String(meta.type).toLowerCase() : 'string';
          if (type.includes('number') || type === 'int' || type === 'float') return randomNumber(3);
          return `sample_${randomString(5)}`;
        };
        const handleDownloadSample = () => {
          try {
            const headers = [...requiredHeaders, ...optionalScheduleHeaders];
            const row = headers.map(h => {
              const keyLower = String(h).trim().toLowerCase();
              return sampleValueFor(keyLower);
            });
            let csv = '\uFEFF' + headers.join(',') + '\n';
            // escape values with commas/quotes/newlines
            const escaped = row.map(v => {
              let val = String(v ?? '');
              if (/[",\n\r]/.test(val)) {
                val = '"' + val.replace(/"/g, '""') + '"';
              }
              return val;
            });
            csv += escaped.join(',') + '\n';
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'sample_campaign_batch.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          } catch (e) {}
        };
        const getScheduleColumn = (headers, key) => {
          const normalizedKey = normalizeCsvHeader(key);
          return headers.find((header) => normalizeCsvHeader(header) === normalizedKey);
        };

        const normalizePhoneNumberValue = (value) => {
          const trimmedValue = String(value || '').trim();
          const localNumberMatch = trimmedValue.match(/^\d{10}$/);
          const countryCodeNumberMatch = trimmedValue.match(/^\+91\s?(\d{10})$/);

          if (localNumberMatch) {
            return trimmedValue;
          }

          if (countryCodeNumberMatch) {
            return countryCodeNumberMatch[1];
          }

          return null;
        };

        const validateAndNormalizePhoneNumbers = (rows) => {
          for (let index = 0; index < rows.length; index += 1) {
            const row = rows[index] || {};
            const normalizedPhoneNumber = normalizePhoneNumberValue(row[phoneNumberColumn]);

            if (!normalizedPhoneNumber) {
              showToast(`Row ${index + 2}: phone number must be 10 digits, +91 followed by 10 digits, or +91 space followed by 10 digits.`, 'error');
              return false;
            }

            row[phoneNumberColumn] = normalizedPhoneNumber;
          }

          return true;
        };

        const parseScheduledDateTime = (dateValue, timeValue) => {
          const normalizedDate = String(dateValue || '').trim();
          const normalizedTime = String(timeValue || '').trim();
          const yearFirstMatch = normalizedDate.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
          const dayFirstMatch = normalizedDate.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
          const timeMatch = normalizedTime.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);

          if (!timeMatch) {
            return null;
          }

          const [, hourValue, minuteValue, secondValue = '0'] = timeMatch;
          const hour = Number(hourValue);
          const minute = Number(minuteValue);
          const second = Number(secondValue);

          if (hour > 23 || minute > 59 || second > 59) {
            return null;
          }

          let year;
          let month;
          let day;
          if (yearFirstMatch) {
            [, year, month, day] = yearFirstMatch;
          } else if (dayFirstMatch) {
            [, day, month, year] = dayFirstMatch;
          } else {
            return null;
          }

          const numericYear = Number(year);
          const numericMonth = Number(month);
          const numericDay = Number(day);
          const validationDate = new Date(Date.UTC(numericYear, numericMonth - 1, numericDay));
          if (
            validationDate.getUTCFullYear() !== numericYear
            || validationDate.getUTCMonth() !== numericMonth - 1
            || validationDate.getUTCDate() !== numericDay
          ) {
            return null;
          }

          const pad = (value) => String(value).padStart(2, '0');
          // The backend interprets campaign schedules in Asia/Kolkata. Include
          // the fixed IST offset so validation is independent of browser zone.
          return new Date(`${numericYear}-${pad(numericMonth)}-${pad(numericDay)}T${pad(hour)}:${pad(minute)}:${pad(second)}+05:30`);
        };

        const normalizeParsedRows = (rows) => (Array.isArray(rows) ? rows.map((row) => {
          const normalizedRow = {};
          Object.entries(row || {}).forEach(([key, value]) => {
            normalizedRow[normalizeCsvHeader(key)] = value;
          });
          return normalizedRow;
        }) : []);

        const removeEmptyRows = (rows) => rows.filter((row) => (
          Object.values(row || {}).some((value) => String(value ?? '').trim() !== '')
        ));

        const validateRequiredColumns = (headers) => {
          const normalizedHeaders = headers.map(normalizeCsvHeader);
          const missing = requiredHeaders
            .map(normalizeCsvHeader)
            .filter(col => !normalizedHeaders.includes(col));
          if (missing.length > 0) {
            setStatement('error');
            showToast(`Missing required columns: ${missing.join(', ')}`, 'error');
            return false;
          }
          return true;
        };

        const validateScheduleColumns = (headers, rows) => {
          const scheduledDateColumn = getScheduleColumn(headers, 'scheduled date');
          const scheduledTimeColumn = getScheduleColumn(headers, 'scheduled time');
          const hasScheduledDate = Boolean(scheduledDateColumn);
          const hasScheduledTime = Boolean(scheduledTimeColumn);

          if (hasScheduledDate !== hasScheduledTime) {
            showToast('CSV must include both scheduled date and scheduled time columns, or neither.', 'error');
            return false;
          }

          if (!hasScheduledDate && !hasScheduledTime) {
            return true;
          }

          for (let index = 0; index < rows.length; index += 1) {
            const row = rows[index] || {};
            const scheduledDateValue = String(row[scheduledDateColumn] ?? '').trim();
            const scheduledTimeValue = String(row[scheduledTimeColumn] ?? '').trim();

            if (!scheduledDateValue && !scheduledTimeValue) {
              continue;
            }

            if (!scheduledDateValue || !scheduledTimeValue) {
              showToast(`Row ${index + 2}: scheduled date and scheduled time must both be present.`, 'error');
              return false;
            }

            const scheduledAt = parseScheduledDateTime(scheduledDateValue, scheduledTimeValue);
            if (!scheduledAt || Number.isNaN(scheduledAt.getTime())) {
              showToast(`Row ${index + 2}: scheduled date and scheduled time are invalid.`, 'error');
              return false;
            }

            if (scheduledAt <= new Date()) {
              showToast(`Row ${index + 2}: scheduled date and time must be in the future.`, 'error');
              return false;
            }
          }

          return true;
        };
        if (!isOpen) return null;
        const handleBulkRecord = async () => {
          try {
            if(apiCallRunning){
              return;
            }
            setApiCallRunning(true);
            // ensure file is present
            if(!selectedFile){
              showToast("Please upload a CSV file first.", "error");
              setApiCallRunning(false);
              return;
            }
            setLoading(true)
            // Ensure CSV content is ready – parse here if user clicked too quickly
            let csvContentLocal = csvFile;
            if (!csvContentLocal) {
              csvContentLocal = await new Promise((resolve, reject) => {
                Papa.parse(selectedFile, {
                  header: true,
                  transformHeader: (h) => (h || '').trim().toLowerCase(),
                  skipEmptyLines: true,
                  complete: (results) => {
                    const headers = (results?.meta?.fields || []).map(normalizeCsvHeader);
                    const normalizedRows = removeEmptyRows(normalizeParsedRows(results.data || []));
                    if (!validateRequiredColumns(headers)) {
                      resolve(null);
                      return;
                    }
                    if (!validateAndNormalizePhoneNumbers(normalizedRows)) {
                      resolve(null);
                      return;
                    }
                    if (!validateScheduleColumns(headers, normalizedRows)) {
                      resolve(null);
                      return;
                    }
                    resolve(normalizedRows);
                  },
                  error: (err) => reject(err)
                });
              }).catch((err) => {
                showToast(err?.message || "Failed to parse CSV", "error");
                return null;
              });
              if (!csvContentLocal) {
                setApiCallRunning(false);
                setLoading(false);
                return;
              }
              setCsvFile(csvContentLocal);
            }
    
            const actualCampaignId = campaignIdProp ? campaignIdProp : (campaignId ? decodeURIComponent(campaignId) : campaignId);
            let formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("content", JSON.stringify(csvContentLocal));
            formData.append("service_id", "");
            formData.append("client_id", client_id);
            formData.append("campaign_id", actualCampaignId);
            formData.append("menu", "campaigns");
            formData.append("submenu", undefined);
            formData.append("email", email);
            formData.append("max_retries", maxRetries);
            formData.append("phone", phone);
            formData.append("agent", agent);
            let resp = await server.upload_voice_agent_campaign_batch(formData);
            let responseBody = {};
            try {
              responseBody = await resp.json();
            } catch (e) {}
            if(resp.status === 200){
              showToast(responseBody?.message || "Batch created successfully.", "success");
              await getCampaignDetails();
              setCsvFile(null)
              setCsvFileName(null)
              setSelectedFile(null)
              setApiCallRunning(false)
              setLoading(false)   
              setShowBulkUploadModal(false)    
            } else {
              showToast(responseBody?.error || "Failed to create batch.", "error");
              setApiCallRunning(false)
              setLoading(false)
            }
          } catch (error) {
            showToast(error?.message || "Failed to create batch.", "error");
            setShowBulkUploadModal(false)
            setApiCallRunning(false)
            setLoading(false)
          }
        }
        const handleFileUpload = (e) => {
          const file = e.target?.files && e.target.files[0];
          if (!file) return;
          setCsvFile(null);
          setStatement(null);
          setSelectedFile(file);
          setCsvFileName(file.name);
          setLoading(true);
          Papa.parse(file, {
            header: true,
            transformHeader: (h) => (h || '').trim().toLowerCase(),
            skipEmptyLines: true,
            complete: (results) => {
              try {
                const headers = (results?.meta?.fields || []).map(normalizeCsvHeader);
                const normalizedRows = removeEmptyRows(normalizeParsedRows(results.data || []));
                if (!validateRequiredColumns(headers)) {
                  setLoading(false);
                  return;
                }
                if (!validateAndNormalizePhoneNumbers(normalizedRows)) {
                  setStatement('error');
                  setLoading(false);
                  return;
                }
                if (!validateScheduleColumns(headers, normalizedRows)) {
                  setStatement('error');
                  setLoading(false);
                  return;
                }
                setCsvFile(normalizedRows);
                setLoading(false);
              } catch (e) {
                setLoading(false);
              }
            },
            error: (err) => {
              showToast(err?.message || "Failed to parse CSV", "error");
              setLoading(false);
            }
          });
        }
        return (
          <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-4" style={{background: "rgba(0,0,0,0.5)"}}>
            <div className="bg-white rounded-lg shadow-xl w-full" style={{height: "93vh", maxWidth: "800px"}}>
              <div className="p-4 border-b flex justify-between items-center">
                <h2 className="text-xl font-semibold" style={{fontSize: "18px"}}>Bulk Upload</h2>
                <FaTimes onClick={onClose} className='cursor-pointer h-4 w-4 text-slate-500' />
              </div>
              
              {!loading && <div className="p-4 space-y-4" style={{height: "76vh", overflow: "auto"}}>
                <div className="bg-blue-50 p-4 rounded-md flex items-start">
                  <IoAlertCircleOutline className="text-blue-500 w-5 h-5 mt-0.5 mr-2 flex-shrink-0" />
                  <div>
                    <p className="text-sm text-blue-800">Your CSV should include the following fields:</p>
                    <ul className="text-xs text-blue-700 mt-1 list-disc list-inside">
                      {requiredHeaders.map((h) => (
                        <li key={h}>{h}</li>
                      ))}
                      <li>SCHEDULED DATE (Optional, dd-mm-yyyy, required if Scheduled Time is provided, interpreted in IST)</li>
                      <li>SCHEDULED TIME (Optional, 24-hour HH:MM, required if Scheduled Date is provided, interpreted in IST)</li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-center justify-center">
                  <button onClick={handleDownloadSample} className="flex items-center px-4 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px"}}>
                    Download sample CSV format
                  </button>
                </div>

                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
                    <div className="flex text-sm text-gray-600 justify-center" style={{fontSize: "13px"}}>
                      <label className="relative cursor-pointer rounded-md font-medium text-indigo-600">
                        <span>Upload a CSV file</span>
                        <input type="file" accept=".csv" className="global-input sr-only" onChange={handleFileUpload} ref={fileRef} />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">CSV up to 50MB</p>
                    {csvFile && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-700">{csvFileName}</p>
                        </div>
                      )}
                  </div>
                </div>
                {statement && (<div style={{textAlign: "center", fontSize: "13px", color: (statement === 'success') ? "green":"red"}}>{statement === 'success' ? '':'Invalid CSV format. Please use the provided sample format.'}</div>)}
              </div>}
              {loading && (<div className="flex justify-center items-center" style={{ height: "77vh", flexDirection: "column" }}>
                            <div className="loader"></div>
                            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                          </div>)}
              
              <div className="p-4 border-t flex justify-end gap-3">
                <button 
                  onClick={onClose} 
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px"}}
                >
                  Cancel
                </button>
                <button onClick={handleBulkRecord} disabled={apiCallRunning}
                  className={`px-4 py-2 ${apiCallRunning ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'} text-white rounded-md`}
                  style={{ padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        );
      };
      const handleSaveDetailsConfig = async () => {
        try {
          setLoading(true)
          let res = await server.update_voice_agent_campaign(client_id, null, email, campaignIdProp, maxRetries, phone);
          if(res.status === 200){
            setLoading(false)
            setInputChangeDetected(false)
            showToast("Details updated successfully", "success");
          }
        } catch (error) {
          setLoading(false)
        }
      }
      const handleConversationsBasedOnBatch = (batch_campaign_id) => {
        setShowConversationPage(true)
        setSegmentData({'filter_applied': {'agent': agent, 'campaign_batch_id': batch_campaign_id}})
      }
    return (
        <div style={{ padding: '0 1rem', width: "100%", height: (window.location.href.includes('?token=')) ? window.innerHeight : window.innerHeight - 66.5, overflowY: "auto" }} className="bg-gray-50">
            {
                    !loading && !showBulkUploadModal && (
                      <>
                      {!window.location.href.includes('?token=') && <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px',}}>
                      <MdArrowBack style={{ marginRight: '8px' }} />
                      Back
                    </button>}
                      {
                        !campaignDetailAvailable ? (
                          <>
                          <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                                    <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                                    <h2 style={{textAlign: "center", fontSize: "24px"}}>No Campaigns Details Found.</h2>
                                </div>
                          </>
                        ) : (
                            <div style={{ height: (window.location.href.includes('?token=')) ? "100%" : "auto"}}>
                                <div className="flex justify-between w-full py-4">
                                    <div style={{display: "flex", gap: "10px", alignItems: "end"}}>
                                        <div>
                                            <div style={{fontSize: "13px"}}>Agent ID</div>
                                            <input type="text" disabled value={agent} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
                                        </div>
                                        <div>
                                            <div style={{fontSize: "13px"}}>Max Retries</div>
                                            <input type="number" value={maxRetries} onChange={(e)=>{setMaxRetries(e.target.value); setInputChangeDetected(true)}} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
                                        </div>
                                        <div>
                                            <div style={{fontSize: "13px"}}>Phone</div>
                                            <input type="text" value={phone} onChange={(e)=>{setPhone(e.target.value); setInputChangeDetected(true)}} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
                                        </div>
                                        {
                                            inputChangeDetected && (
                                                <div>
                                                    <button onClick={handleSaveDetailsConfig} className="flex items-center px-4 py-2 rounded text-sm text-white hover:opacity-90" style={{ backgroundColor: "rgb(79, 70, 229)" }}>Save</button>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="flex items-center">
                                    <button className="flex items-center px-4 py-2 rounded text-sm text-white hover:opacity-90" style={{ backgroundColor: "rgb(79, 70, 229)" }} onClick={()=>{setShowBulkUploadModal(true);}}>Create Batch</button>
                                    </div>
                                </div>
                                <div>
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead style={{ position: "sticky", top: "0" }}>
                                            <tr>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Campaign Batch ID</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Total Records</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Total Initiated</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Success Count</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Failed Count</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Created At</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Status</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {batches.map((batch) => (
                                            <tr key={batch.campaign_batch_id} className="hover:bg-gray-50">
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-blue-600" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.campaign_batch_id}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.total_records}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.total_initiated}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.success_count}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-500" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.failed_count}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDateString(batch.created_at)}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900 capitalize" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{batch.status}</td>
                                                <td className="px-5 py-3 whitespace-nowrap text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                                  <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
                                                  {batch.status === 'queued' && (
                                                      <button
                                                        className="cancel-btn"
                                                        onClick={() => handleCancelBatchClick(batch.campaign_batch_id)}
                                                        disabled={cancelApiRunning}
                                                      >
                                                        Cancel
                                                      </button>
                                                    )}
                                                    {batch.status !== 'cancelled' && batch.status !== 'queued' && <button className="view-details-btn" onClick={()=>handleConversationsBasedOnBatch(batch.campaign_batch_id)}>View Details</button>}
                                                    {batch.status !== 'queued' && batch.status !== 'completed' && 'NA'}
                                                  </div>
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                        }
                    </>)}
                    {
                        loading && !showBulkUploadModal && (
                            <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                <div className="loader"></div>
                                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                            </div>
                        )
                    }
                    {
                      showBulkUploadModal && (
                        <BulkUploadModal isOpen={showBulkUploadModal} onClose={()=>{setShowBulkUploadModal(false); }} selectedCampaignID={selectedCampaignID}/>
                      )
                    }
                    {
                      showCancelModal && (
                        <CancelBatchModal
                          isOpen={showCancelModal}
                          onClose={() => { setShowCancelModal(false); setCancelBatchId(null); }}
                          onConfirm={handleConfirmCancelBatch}
                        />
                      )
                    }
                    {
                      showConversationPage && (
                        <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "2%", width: "96%", height: "96%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999"}}>
                          <div className="flex items-center justify-end">
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationPage(false);}}><FaTimes style={{color: "slategray"}}/></div>
                          </div>
                          <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
                            <ConversationRecords clientID={client_id} segment={segmentData}/>
                          </div>
                        </div>
                        </div>
                      )
                    }
                    <style jsx>
                        {`
                            .timeline {
                                position: relative;
                            }

                            .timeline-line {
                                position: absolute;
                                left: 1rem;
                                top: 0;
                                bottom: 0;
                                width: 2px;
                                background-color: #e5e7eb;
                            }
                            .status-indicator {
                                position: absolute;
                                left: 0.25rem;
                                width: 1.5rem;
                                height: 1.5rem;
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.875rem;
                                margin-top: 24px;
                            }

                            .status-indicator.call {
                                background-color: white;
                                color: black;
                            }

                            .status-indicator.ticket {
                                background-color: #fefce8;
                                color: #a16207;
                            }
                            .view-details-btn {
                                transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
                                border: 1px solid rgb(209 213 217);
                                width: 90px;
                                font-size: 12px;
                                text-align: center;
                                padding: 3px;
                                border-radius: 6px;
                                cursor: pointer;
                                background: white;
                            }

                            .view-details-btn:hover {
                                background: rgb(249, 250, 251);
                            }
                            .cancel-btn {
                                transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
                                border: 1px solid rgb(248 113 113);
                                width: 76px;
                                font-size: 12px;
                                text-align: center;
                                padding: 3px;
                                border-radius: 6px;
                                cursor: pointer;
                                background: white;
                                color: rgb(239 68 68);
                            }
                            .cancel-btn:hover {
                                background: rgb(254 242 242);
                            }
                            .sections-headings {
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 10px;
                            background: rgba(255, 255, 255, 0.28);
                            border-radius: 10px;
                            transition: background 0.3s;
                            }

                            .sections-headings.expanded {
                            border-bottom: 1px solid rgb(227, 227, 227);
                            border-radius: 10px 10px 0 0;
                            }

                            .sections-headings:hover {
                            background: rgb(249, 250, 251);
                            }

                            .section-title {
                            font-size: 15px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            }

                        `}
                    </style>
        </div>
    )
}

export default CampaignDetails;
